import { gql } from "@apollo/client";

export const GET_DSP_ADJUST_BILL_DETAILS_CSV_URL = gql`
  query GetDspAdjustBillDetailsCsvUrl($taskId: ID!) {
    getDspAdjustBillDetailsCsvUrl(taskId: $taskId)
  }
`;

export interface GetDspAdjustBillDetailsCsvUrlData {
  getDspAdjustBillDetailsCsvUrl: string;
}

export interface GetDspAdjustBillDetailsCsvUrlVariables {
  taskId: number;
}
